const TITLE_PREFIX = /^(mr|mrs|miss|ms|dr|prof|rev)\.?\s+/i;

export function getFirstName(fullName?: string | null): string {
  if (!fullName) return '';
  const withoutTitle = fullName.replace(TITLE_PREFIX, '').trim();
  return (withoutTitle || fullName).split(' ')[0];
}
